import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import cn from 'classnames'

import { IBreadCrumbs } from './breadcrumbs.interface'
import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

export default function BreadCrumbs({ pages, isInverted }: IBreadCrumbs) {
  const { t } = useTranslation()
  const router = useRouter()

  if (!pages && !isInverted) {
    return (
      <div className={styles.breadcrumbs}>
        <a className={styles.breadcrumbsLink} onClick={router.back}>
          &lt;&nbsp;&nbsp;Back
        </a>
      </div>
    )
  }

  return (
    <>
      {!isInverted && (
        <div className={cn('container', styles.wrapper)}>
          <Link prefetch={false} href="/">
            <a>{t('main')}</a>
          </Link>
          {pages.map((page) => (
            <React.Fragment key={page.name}>
              <span className={styles.arrow}>&gt;</span>
              {page.url ? (
                <Link prefetch={false} href={page.url}>
                  <a key={page.name}>{page.name}</a>
                </Link>
              ) : (
                <span>{page.name}</span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
      {isInverted && (
        <div className={styles.breadcrumbs}>
          {pages.map((page) => (
            <>
              {page.url ? (
                <React.Fragment key={page.name}>
                  <span className={styles.breadcrumbsArrow}>&lt;</span>
                  <Link prefetch={false} href={page.url}>
                    <a className={styles.breadcrumbsLink}>{page.name}</a>
                  </Link>
                </React.Fragment>
              ) : (
                <span className={styles.breadcrumbsCurrentPage}>{page.name}</span>
              )}
            </>
          ))}
        </div>
      )}
    </>
  )
}
